import React from 'react';
import ReportingFoodAndBeverageToastSalesPage from '../components/ReportingFoodAndBeverageToastSalesPage';

const axios = require('axios').default;

const ReportingFoodAndBeverageToastSalesApp = (props) => {
  if (props.csrfToken) {
    axios.defaults.headers.common['X-CSRF-TOKEN'] = props.csrfToken;
  }
  return <ReportingFoodAndBeverageToastSalesPage {...props} />;
};

export default ReportingFoodAndBeverageToastSalesApp;
